export enum CityAreasActions {
  GetCityAreas = '[Pending] Get CityAreas',
  GetCityAreasSuccess = '[Success] Get CityAreas',
  GetCityAreasError = '[Error] Get CityAreas',
}
